import moment from "moment-mini";

const FormatMomentDate = (date, formatTo = 'MM/DD/YYYY'  ) => {
 
    if (date) {
        return  moment(date).format(formatTo)
    }
    return ""
 
};

export default FormatMomentDate;
